import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Stack from "@mui/material/Stack";
import cookie from "react-cookies";

import actions from "actions";
import MatchingCalendar from "./MatchingCalendar";
import MatchPanel from "./MatchingPanel";
import BCBACaseload from "./BCBACaseload";
import { MatchingProvider } from "./MatchingProvider";
import RefreshDialog from "./RefreshDialog";

function Matching() {
  const dispatch = useDispatch();
  const [showCaseload, setShowCaseload] = useState(false);
  const [refreshDialogOpen, setRefreshDialogOpen] = useState(false);
  const userId = cookie.load("userId");

  const openRefreshDialog = (e) => {
    e.stopPropagation();
    setRefreshDialogOpen(true);
  };

  useEffect(() => {
    dispatch(
      actions.setPageDetails({
        pageName: "Matching",
        currentPage: "matching",
        menu: "matchingHome",
      })
    );
  }, [dispatch]);

  return (
    <MatchingProvider>
      <Stack
        direction="row"
        component="main"
        width="100%"
        // 131px and 156px are fixed values for toolbar height for different screen
        height={{ xs: "calc(100vh - 156px)", lg: "calc(100vh - 131px)" }}
      >
        {showCaseload ? (
          <BCBACaseload setShowCaseload={setShowCaseload} />
        ) : (
          <MatchPanel
            setShowCaseload={setShowCaseload}
            onRefresh={(e) => openRefreshDialog(e)}
          />
        )}

        <MatchingCalendar />

        <RefreshDialog
          userId={userId}
          isOpen={refreshDialogOpen}
          handleClose={() => setRefreshDialogOpen(false)}
        />
      </Stack>
    </MatchingProvider>
  );
}

export default Matching;
